import * as THREE from 'three';

const GRID_DIVISION_SIZE = 100;
const GRID_CENTER_COLOR = 0x202020;
const GRID_LINE_COLOR = 0x808080;

export function createGrid(
  scene: THREE.Scene,
  bbox: THREE.Box3,
  existingGrid: THREE.GridHelper | null,
): THREE.GridHelper {
  if (existingGrid) scene.remove(existingGrid);

  const center = bbox.getCenter(new THREE.Vector3());
  const dims = bbox.getSize(new THREE.Vector3());
  const largest = Math.max(dims.x, dims.y, dims.z);

  const numDivisions = 2 * Math.ceil(largest / GRID_DIVISION_SIZE);
  const grid = new THREE.GridHelper(
    GRID_DIVISION_SIZE * numDivisions,
    numDivisions,
    GRID_CENTER_COLOR,
    GRID_LINE_COLOR,
  );
  grid.rotation.x = Math.PI / 2;
  grid.position.set(center.x, center.y, center.z - dims.z / 2);
  scene.add(grid);
  return grid;
}
